
import { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import PageTransition from '@/components/PageTransition';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ProfileSection from '@/components/account/ProfileSection';
import UsageStats from '@/components/account/UsageStats';
import SubscriptionSection from '@/components/account/SubscriptionSection';
import LeaguesSection from '@/components/account/LeaguesSection';
import { Loader2 } from 'lucide-react';
const Account = () => {
  const {
    user,
    loading
  } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profile');

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!loading && !user) {
      navigate('/login', {
        state: {
          returnTo: '/account'
        }
      });
    }
  }, [user, loading, navigate]);
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>;
  }
  return <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <PageTransition>
        <main className="flex-1 py-12 container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-6">Account Settings</h1>
            
            <Tabs defaultValue="profile" value={activeTab} onValueChange={setActiveTab} className="w-full">
              <TabsList className="grid grid-cols-3 mb-8">
                <TabsTrigger value="profile">Profile</TabsTrigger>
                <TabsTrigger value="leagues">Leagues</TabsTrigger>
                <TabsTrigger value="subscription">Subscription</TabsTrigger>
              </TabsList>
              
              <TabsContent value="profile">
                <ProfileSection />
              </TabsContent>
              
              <TabsContent value="leagues">
                <LeaguesSection />
              </TabsContent>
              
              <TabsContent value="subscription">
                <SubscriptionSection />
              </TabsContent>
            </Tabs>
          </div>
        </main>
      </PageTransition>
      
      <Footer />
    </div>;
};
export default Account;
